import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.span<{ color?: string; hasTooltip?: boolean }>(
  ({ color, hasTooltip, theme }) => `
  background: ${theme.palette.grey['100']};
  box-shadow: inset 0 0 0 1px ${theme.palette.grey['200']};
  border-radius: 20px;
  color: ${theme.palette.common.black};
  cursor: ${hasTooltip ? 'help' : 'default'};
  display: inline-flex;
  max-width: 100%;
  padding: ${color || hasTooltip ? 0 : `${rem(4)} ${rem(16)}`};
  user-select: none;
  width: max-content;

  .chip-tooltip-anchor {
    padding: ${rem(4)} ${rem(16)};
  }

  ${
    color &&
    `${Content} {
      font-size: ${rem(12)};
      font-weight: 500;
      line-height: ${rem(16)};
      gap: ${rem(4)};
      padding: ${rem(4)} ${rem(8)};

      &::before {
        content: '';
        background: ${color};
        border-radius: 50%;
        width: ${rem(8)};
        height: ${rem(8)};
      }
    }`
  }

  .icon {
    width: ${rem(14)};
    height: ${rem(14)};
    flex-shrink: 0;
  }

  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
);

const Content = styled.span`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  text-transform: capitalize;
`;

export default {
  Wrapper,
  Content
};
